import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import api from "../api";
import { Modal, KindBadge, KINDS, TagPicker } from "./ui";
import { StageBadge } from "./leadStages";

const JUNK = new Set(["io", "me", "tu", "cliente", "utente", "lead", "info", "test", "whatsapp", "contatto"]);
const looksWrong = (p) => {
  const fn = (p?.first_name || "").trim();
  return !fn || JUNK.has(fn.toLowerCase()) || /^\+?\d+$/.test(fn) || !(p?.last_name || "").trim();
};

export default function SenderCard({ email = "", phone = "", senderName = "", onChanged }) {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(() => window.innerWidth > 820);
  const [linkModal, setLinkModal] = useState(false);
  const [allCompanies, setAllCompanies] = useState([]);
  const [selCompany, setSelCompany] = useState("");
  const [busy, setBusy] = useState("");
  const [mailLinkModal, setMailLinkModal] = useState(false);
  const [mlCompany, setMlCompany] = useState("");
  const [mlScope, setMlScope] = useState("email");
  const [contact, setContact] = useState(null);
  const [attach, setAttach] = useState(null);
  const [attachPersons, setAttachPersons] = useState([]);
  const [attachLeads, setAttachLeads] = useState([]);
  const [tagModal, setTagModal] = useState(false);
  const [allTags, setAllTags] = useState([]);
  const [tagSel, setTagSel] = useState([]);
  const [newTagName, setNewTagName] = useState("");
  const [newTagColor, setNewTagColor] = useState("#3b82f6");

  const openTags = (person) => {
    setTagSel(person.tag_ids || []);
    setNewTagName("");
    setTagModal(true);
    api.get("/tags").then((r) => setAllTags(r.data)).catch(() => {});
  };
  const createTag = async () => {
    if (!newTagName.trim()) return;
    try {
      const r = await api.post("/tags", { name: newTagName.trim(), color: newTagColor });
      setAllTags((t) => [...t, r.data]);
      setTagSel((s) => [...s, r.data.id]);
      setNewTagName("");
    } catch (e) { alert(e?.response?.data?.detail || e.message); }
  };
  const saveTags = async (personId) => {
    setBusy("tags");
    try {
      await api.put(`/persons/${personId}`, { tag_ids: tagSel });
      setTagModal(false); load(); onChanged && onChanged();
    } catch (e) { alert(e?.response?.data?.detail || e.message); }
    finally { setBusy(""); }
  };

  const openContact = () => {
    const nm = (senderName || "").trim();
    const parts = nm.split(" ");
    setContact({
      first_name: parts[0] || (phone ? "Contatto" : nm) || "",
      last_name: parts.slice(1).join(" "),
      email: email || "", phone: phone || "",
      kind: "lead", company_id: "", role: "",
    });
    if (allCompanies.length === 0) api.get("/companies").then((r) => setAllCompanies(r.data)).catch(() => {});
  };
  const saveContact = async () => {
    if (!contact.first_name.trim()) { alert("Indica almeno il nome"); return; }
    try {
      const chk = await api.get("/persons/by-contact", { params: { email: contact.email.trim(), phone: contact.phone.trim() }, noCache: true });
      const ex = chk.data?.person;
      if (ex) {
        const exName = `${ex.first_name || ""} ${ex.last_name || ""}`.trim();
        if (!window.confirm(`⚠️ Esiste già "${exName}" in anagrafica con questa email/telefono.\n\nOK = creo comunque un DOPPIONE (sconsigliato)\nAnnulla = non creo nulla`)) { setContact(null); return; }
      }
    } catch (_) {}
    try {
      const r = await api.post("/persons", {
        first_name: contact.first_name.trim(), last_name: contact.last_name.trim() || "—",
        kind: contact.kind, email: contact.email.trim() || null, phone: contact.phone.trim() || null,
        role: contact.role.trim() || null, notes: "Creato dal mittente di un messaggio",
      });
      if (contact.company_id) {
        try { await api.post("/persons/links", { person_id: r.data.id, company_id: contact.company_id, role: contact.role.trim() || null }); } catch (_) {}
      }
      setContact(null);
      alert("Anagrafica creata" + (contact.company_id ? " e collegata al cliente." : ". Il mittente ora è riconosciuto."));
      load(); onChanged && onChanged();
    } catch (e) { alert("Errore: " + (e?.response?.data?.detail || e.message)); }
  };
  const openAttach = () => {
    setAttach({ target: "person", id: "", q: "" });
    if (attachPersons.length === 0) api.get("/persons").then((r) => setAttachPersons(r.data)).catch(() => {});
    if (allCompanies.length === 0) api.get("/companies").then((r) => setAllCompanies(r.data)).catch(() => {});
    if (attachLeads.length === 0) api.get("/pipeline?view=all").then((r) => setAttachLeads(Array.isArray(r.data) ? r.data : r.data.leads || [])).catch(() => {});
  };
  const saveAttach = async () => {
    const val = (email || phone || "").trim();
    if (!attach.id || !val) return;
    const field = phone && !email ? "phone" : "email";
    const fieldLabel = field === "phone" ? "il telefono" : "l'email";
    try {
      if (attach.target === "lead") {
        await api.post(`/pipeline/${attach.id}/attach-contact`, { [field]: val });
        const l = attachLeads.find((x) => x.id === attach.id);
        setAttach(null);
        alert(`Collegato al lead "${l?.name || l?.email || ""}": tutti i suoi messaggi (anche futuri) compariranno nella cronologia del lead.`);
      } else if (attach.target === "person") {
        const p = attachPersons.find((x) => x.id === attach.id);
        const cur = (p?.[field] || "").trim();
        if (cur && cur.toLowerCase() !== val.toLowerCase()
          && !window.confirm(`${p.first_name || ""} ${p.last_name || ""} ha già ${fieldLabel} "${cur}".\nLo sostituisco con "${val}"?`)) return;
        await api.put(`/persons/${attach.id}`, { [field]: val });
        setAttach(null);
        alert("Anagrafica aggiornata: il mittente ora è riconosciuto, anche per i messaggi futuri.");
      } else {
        const c = allCompanies.find((x) => x.id === attach.id);
        const cur = (c?.[field] || "").trim();
        if (cur && cur.toLowerCase() !== val.toLowerCase()
          && !window.confirm(`${c.name} ha già ${fieldLabel} "${cur}".\nLo sostituisco con "${val}"?`)) return;
        await api.put(`/companies/${attach.id}`, { [field]: val });
        setAttach(null);
        alert("Anagrafica aggiornata: il mittente ora è riconosciuto, anche per i messaggi futuri.");
      }
      load(); onChanged && onChanged();
    } catch (e) { alert("Errore: " + (e?.response?.data?.detail || e.message)); }
  };

  const contactModalEl = contact ? (
    <Modal title="Crea anagrafica dal mittente" onClose={() => setContact(null)}>
      <div className="grid-2">
        <div className="field"><label>Nome *</label><input value={contact.first_name} onChange={(e) => setContact({ ...contact, first_name: e.target.value })} data-testid="sc-contact-first" /></div>
        <div className="field"><label>Cognome</label><input value={contact.last_name} onChange={(e) => setContact({ ...contact, last_name: e.target.value })} data-testid="sc-contact-last" /></div>
        <div className="field"><label>Email</label><input value={contact.email} onChange={(e) => setContact({ ...contact, email: e.target.value })} data-testid="sc-contact-email" /></div>
        <div className="field"><label>Telefono</label><input value={contact.phone} onChange={(e) => setContact({ ...contact, phone: e.target.value })} data-testid="sc-contact-phone" /></div>
      </div>
      <div className="field"><label>Tipo</label>
        <select value={contact.kind} onChange={(e) => setContact({ ...contact, kind: e.target.value })} data-testid="sc-contact-kind">
          {KINDS.map((k) => <option key={k.value} value={k.value}>{k.label}</option>)}
        </select>
      </div>
      <div className="grid-2">
        <div className="field"><label>Collega a un cliente <span className="muted">(facoltativo)</span></label>
          <select value={contact.company_id} onChange={(e) => setContact({ ...contact, company_id: e.target.value })} data-testid="sc-contact-company">
            <option value="">— nessuna azienda —</option>
            {allCompanies.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        </div>
        <div className="field"><label>Ruolo</label>
          <input placeholder="es. Consulente paghe, Socio…" value={contact.role} onChange={(e) => setContact({ ...contact, role: e.target.value })} data-testid="sc-contact-role" />
        </div>
      </div>
      <div className="modal-actions">
        <button className="btn" onClick={() => setContact(null)}>Annulla</button>
        <button className="btn primary" onClick={saveContact} data-testid="sc-contact-save">Crea anagrafica</button>
      </div>
    </Modal>
  ) : null;

  const attachModalEl = attach ? (
    <Modal title="Aggiungi ad anagrafica esistente" onClose={() => setAttach(null)}>
      <p className="muted">{phone && !email ? "Il numero" : "L'indirizzo"} <strong>{email || phone}</strong> verrà salvato sulla scheda scelta: i messaggi (anche futuri) verranno riconosciuti e raggruppati su quella anagrafica.</p>
      <div className="field"><label>Tipo di anagrafica</label>
        <div style={{ display: "flex", gap: 18 }}>
          <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer" }}>
            <input type="radio" name="sc-attach-target" checked={attach.target === "person"} onChange={() => setAttach({ ...attach, target: "person", id: "" })} data-testid="sc-attach-target-person" /> Persona
          </label>
          <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer" }}>
            <input type="radio" name="sc-attach-target" checked={attach.target === "company"} onChange={() => setAttach({ ...attach, target: "company", id: "" })} data-testid="sc-attach-target-company" /> Azienda
          </label>
          <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer" }}>
            <input type="radio" name="sc-attach-target" checked={attach.target === "lead"} onChange={() => setAttach({ ...attach, target: "lead", id: "" })} data-testid="sc-attach-target-lead" /> 🎯 Lead
          </label>
        </div>
      </div>
      <div className="field"><label>Cerca</label>
        <input value={attach.q} onChange={(e) => setAttach({ ...attach, q: e.target.value })} placeholder="Filtra per nome…" data-testid="sc-attach-search" />
      </div>
      <div className="field"><label>{attach.target === "person" ? "Persona" : attach.target === "company" ? "Azienda" : "Lead"}</label>
        <select value={attach.id} onChange={(e) => setAttach({ ...attach, id: e.target.value })} size={8} style={{ width: "100%" }} data-testid="sc-attach-select">
          {attach.target === "person"
            ? attachPersons
                .filter((p) => `${p.last_name || ""} ${p.first_name || ""}`.toLowerCase().includes(attach.q.toLowerCase()))
                .map((p) => <option key={p.id} value={p.id}>{p.last_name} {p.first_name}{p.email ? ` · ${p.email}` : ""}{p.phone ? ` · ${p.phone}` : ""}</option>)
            : attach.target === "company"
            ? allCompanies
                .filter((c) => (c.name || "").toLowerCase().includes(attach.q.toLowerCase()))
                .map((c) => <option key={c.id} value={c.id}>{c.name}{c.email ? ` · ${c.email}` : ""}{c.phone ? ` · ${c.phone}` : ""}</option>)
            : attachLeads
                .filter((l) => `${l.name || ""} ${l.email || ""}`.toLowerCase().includes(attach.q.toLowerCase()))
                .map((l) => <option key={l.id} value={l.id}>{l.name || "(senza nome)"}{l.email ? ` · ${l.email}` : ""}{l.phone ? ` · ${l.phone}` : ""}</option>)}
        </select>
      </div>
      <div className="modal-actions">
        <button className="btn" onClick={() => setAttach(null)}>Annulla</button>
        <button className="btn primary" onClick={saveAttach} disabled={!attach.id} data-testid="sc-attach-save">Aggiungi all'anagrafica</button>
      </div>
    </Modal>
  ) : null;

  const domain = (email || "").split("@")[1] || "";
  const genericDomain = /gmail|libero|hotmail|outlook|yahoo|icloud|live\.|pec\.it|legalmail|virgilio|tiscali|alice\.it/i.test(domain);

  const openMailLink = () => {
    setMailLinkModal(true); setMlCompany(""); setMlScope(genericDomain ? "email" : "domain");
    if (allCompanies.length === 0) api.get("/companies").then((r) => setAllCompanies(r.data)).catch(() => {});
  };
  const doMailLink = async () => {
    setBusy("maillink");
    try {
      const pattern = mlScope === "domain" ? domain : email;
      const r = await api.post(`/companies/${mlCompany}/sender-links`, { pattern, note: senderName || "" });
      const cname = (allCompanies.find((c) => c.id === mlCompany) || {}).name || "il cliente";
      setMailLinkModal(false); onChanged && onChanged();
      alert(`✅ "${r.data.pattern}" collegato a ${cname}.\nEmail già presenti ricollegate: ${r.data.email_ricollegate}. Le prossime arriveranno già nella sua scheda.`);
    } catch (e) { alert(e?.response?.data?.detail || e.message); }
    finally { setBusy(""); }
  };

  const mailLinkButton = email ? (
    <button className="btn sm" onClick={openMailLink} data-testid="sender-mail-link-btn" title="Le email di questo mittente finiranno automaticamente nella scheda del cliente scelto (es. consulente paghe → suo cliente)">
      🔗 Collega mittente a un cliente
    </button>
  ) : null;

  const mailLinkModalEl = mailLinkModal ? (
    <Modal title="🔗 Collega mittente a un cliente" onClose={() => setMailLinkModal(false)}>
      <p className="muted" style={{ fontSize: 13, marginTop: 0 }}>
        Le email di <strong>{senderName || email}</strong> verranno collegate automaticamente al cliente scelto
        (compariranno nella sua scheda, ricerca e Area di lavoro). Utile per consulenti e terzi che scrivono per conto di un tuo cliente.
      </p>
      <div className="field"><label>Cliente</label>
        <select value={mlCompany} onChange={(e) => setMlCompany(e.target.value)} data-testid="mail-link-company-select">
          <option value="">— Seleziona —</option>
          {allCompanies.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
      </div>
      <div className="field"><label>Cosa collegare</label>
        <label style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 13 }}>
          <input type="radio" checked={mlScope === "email"} onChange={() => setMlScope("email")} data-testid="mail-link-scope-email" />
          Solo questo indirizzo: <strong>{email}</strong>
        </label>
        {domain && !genericDomain && (
          <label style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 13 }}>
            <input type="radio" checked={mlScope === "domain"} onChange={() => setMlScope("domain")} data-testid="mail-link-scope-domain" />
            Tutto lo studio/dominio: <strong>@{domain}</strong> (chiunque scriva da lì)
          </label>
        )}
      </div>
      <div className="modal-actions">
        <button className="btn" onClick={() => setMailLinkModal(false)}>Annulla</button>
        <button className="btn primary" onClick={doMailLink} disabled={!mlCompany || busy === "maillink"} data-testid="mail-link-confirm">
          {busy === "maillink" ? "Collego…" : "Collega"}
        </button>
      </div>
    </Modal>
  ) : null;

  const load = useCallback(() => {
    if (!email && !phone) return;
    api.get("/persons/by-contact", { params: { email, phone }, noCache: true })
      .then((r) => setData(r.data)).catch(() => setData(null));
  }, [email, phone]);
  useEffect(() => { load(); }, [load]);

  if (!data) return null;
  const p = data.person;

  if (!p) {
    return (
      <div className="panel" style={{ padding: "10px 14px" }} data-testid="sender-card-empty">
        <div style={{ fontSize: 13, marginBottom: 8 }} className="muted">👤 Nessuna anagrafica per questo mittente.</div>
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          <button className="btn sm" onClick={openContact} data-testid="sender-create-contact">➕ Crea anagrafica</button>
          <button className="btn sm" onClick={openAttach} title="Salva il mittente su una persona, azienda o lead già presente" data-testid="sender-attach-contact">🔗 Aggiungi ad anagrafica</button>
          {mailLinkButton}
        </div>
        {mailLinkModalEl}
        {contactModalEl}
        {attachModalEl}
      </div>
    );
  }

  const fullName = `${p.first_name || ""} ${p.last_name || ""}`.trim();
  const warn = looksWrong(p);
  const dups = data.duplicates || [];

  const openLinkCompany = () => {
    setLinkModal(true); setSelCompany("");
    if (allCompanies.length === 0) api.get("/companies").then((r) => setAllCompanies(r.data)).catch(() => {});
  };
  const doLinkCompany = async () => {
    setBusy("link");
    try {
      await api.post("/persons/links", { person_id: p.id, company_id: selCompany, role: null });
      setLinkModal(false); load(); onChanged && onChanged();
    } catch (e) { alert(e?.response?.data?.detail || e.message); }
    finally { setBusy(""); }
  };
  const followLead = async () => {
    setBusy("lead");
    try {
      await api.post("/pipeline", {
        name: fullName || senderName || email || phone,
        email: (p.email || email || "").trim() || null,
        phone: (p.phone || phone || "").trim() || null,
        stage: "da_valutare",
      });
      load();
      alert('Lead creato nella colonna "Da valutare" del funnel.');
    } catch (e) { alert(e?.response?.data?.detail || e.message); }
    finally { setBusy(""); }
  };
  const mergeDup = async (d) => {
    const dn = `${d.first_name || ""} ${d.last_name || ""}`.trim() || d.email || d.phone;
    if (!window.confirm(`Unisco "${dn}" dentro la scheda "${fullName}"?\nRecapiti, etichette e storico verranno conservati; il doppione sarà eliminato.`)) return;
    setBusy("merge-" + d.id);
    try {
      await api.post("/persons/merge", { primary_id: p.id, duplicate_id: d.id });
      load(); onChanged && onChanged();
    } catch (e) { alert(e?.response?.data?.detail || e.message); }
    finally { setBusy(""); }
  };

  return (
    <div className="panel" style={{ padding: "10px 14px" }} data-testid="sender-card">
      <button
        onClick={() => setOpen(!open)}
        data-testid="sender-card-toggle"
        style={{ width: "100%", background: "none", border: "none", padding: 0, cursor: "pointer", display: "flex", alignItems: "center", gap: 8, textAlign: "left" }}
      >
        <span style={{ fontSize: 15 }}>👤 <strong>{fullName || "(senza nome)"}</strong></span>
        <KindBadge kind={p.kind} />
        {warn && <span title="Il nome sembra incompleto o sbagliato: aprire la scheda per correggerlo" data-testid="sender-name-warning" style={{ fontSize: 12, color: "#f59e0b" }}>⚠️ nome da verificare</span>}
        {dups.length > 0 && <span data-testid="sender-dup-badge" style={{ fontSize: 12, color: "#f87171" }}>🧬 {dups.length} doppion{dups.length === 1 ? "e" : "i"}</span>}
        <span className="spacer" style={{ flex: 1 }} />
        <span className="muted" style={{ fontSize: 12 }}>{open ? "▲" : "▼"}</span>
      </button>

      {open && (
        <div style={{ marginTop: 10, borderTop: "1px solid var(--border)", paddingTop: 10 }}>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "6px 16px", fontSize: 13, marginBottom: 8 }}>
            {p.email && <span data-testid="sender-email">✉️ {p.email}</span>}
            {p.phone && <span data-testid="sender-phone">📞 {p.phone}</span>}
            {(data.tags || []).map((t) => (
              <span key={t.id} className="badge" style={{ background: (t.color || "#64748b") + "22", color: t.color || "#64748b", border: `1px solid ${(t.color || "#64748b")}55` }}>{t.name}</span>
            ))}
          </div>

          {(data.companies || []).length > 0 && (
            <div style={{ fontSize: 13, marginBottom: 8 }} data-testid="sender-companies">
              🏢 {data.companies.map((c, i) => (
                <span key={c.id}>{i > 0 && " · "}<Link to={`/aziende/${c.id}`}>{c.name}</Link>{c.role ? ` (${c.role})` : ""}</span>
              ))}
            </div>
          )}

          <div className="toolbar" style={{ gap: 6, flexWrap: "wrap" }}>
            <Link className="btn sm" to={`/persone/${p.id}`} data-testid="sender-open-scheda">📂 Apri scheda</Link>
            <button className="btn sm" onClick={openLinkCompany} data-testid="sender-link-company">🏢 Collega ad azienda</button>
            <button className="btn sm" onClick={() => openTags(p)} data-testid="sender-add-tag">🏷️ Etichetta</button>
            {mailLinkButton}
            {data.lead
              ? <Link className="btn sm" to={`/lead/${data.lead.id}`} data-testid="sender-lead-link">🎯 Nel funnel: <StageBadge stage={data.lead.stage} /></Link>
              : <button className="btn sm" onClick={followLead} disabled={busy === "lead"} data-testid="sender-follow-lead">⭐ Segui come lead</button>}
          </div>

          {dups.length > 0 && (
            <div style={{ marginTop: 10, background: "rgba(248,113,113,.08)", border: "1px solid rgba(248,113,113,.3)", borderRadius: 8, padding: "8px 10px" }} data-testid="sender-duplicates">
              <div style={{ fontSize: 13, marginBottom: 6 }}><strong>🧬 Possibili doppioni in anagrafica</strong> — unendoli conservi recapiti e storico:</div>
              {dups.map((d, i) => (
                <div key={d.id} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, padding: "3px 0", flexWrap: "wrap" }} data-testid={`sender-dup-row-${i}`}>
                  <span><strong>{`${d.first_name || ""} ${d.last_name || ""}`.trim() || "(senza nome)"}</strong>{d.email ? ` · ${d.email}` : ""}{d.phone ? ` · ${d.phone}` : ""}</span>
                  <button className="btn sm" onClick={() => mergeDup(d)} disabled={busy === "merge-" + d.id} data-testid={`sender-merge-${i}`}>
                    {busy === "merge-" + d.id ? "Unisco…" : "Unisci in questa scheda"}
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {tagModal && (
        <Modal title="🏷️ Etichette del contatto" onClose={() => setTagModal(false)}>
          <p className="muted" style={{ fontSize: 13, marginTop: 0 }}>Etichette di <strong>{fullName || p.email || p.phone}</strong> — clicca per aggiungere o togliere.</p>
          <TagPicker tags={allTags} selected={tagSel} onChange={setTagSel} />
          <div className="field" style={{ marginTop: 14 }}><label>Nuova etichetta</label>
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <input value={newTagName} onChange={(e) => setNewTagName(e.target.value)} placeholder="es. Paghe, Urgente…" style={{ flex: 1 }} data-testid="sender-new-tag-name" />
              <input type="color" value={newTagColor} onChange={(e) => setNewTagColor(e.target.value)} style={{ width: 44, height: 34, padding: 2, cursor: "pointer" }} data-testid="sender-new-tag-color" />
              <button className="btn sm" onClick={createTag} disabled={!newTagName.trim()} data-testid="sender-new-tag-create">➕ Crea</button>
            </div>
          </div>
          <div className="modal-actions">
            <button className="btn" onClick={() => setTagModal(false)}>Annulla</button>
            <button className="btn primary" onClick={() => saveTags(p.id)} disabled={busy === "tags"} data-testid="sender-tags-save">{busy === "tags" ? "Salvo…" : "Salva etichette"}</button>
          </div>
        </Modal>
      )}
      {linkModal && (
        <Modal title="Collega ad azienda" onClose={() => setLinkModal(false)}>
          <p className="muted" style={{ fontSize: 13 }}><strong>{fullName}</strong> verrà collegato come referente dell'azienda scelta.</p>
          <div className="field"><label>Azienda</label>
            <select value={selCompany} onChange={(e) => setSelCompany(e.target.value)} data-testid="sender-company-select">
              <option value="">— Seleziona —</option>
              {allCompanies.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
          <div className="modal-actions">
            <button className="btn" onClick={() => setLinkModal(false)}>Annulla</button>
            <button className="btn primary" onClick={doLinkCompany} disabled={!selCompany || busy === "link"} data-testid="sender-company-confirm">Collega</button>
          </div>
        </Modal>
      )}
      {mailLinkModalEl}
    </div>
  );
}
